// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 

/**
 * A simple wrapper around a dictionary providing methods to do common operations.
 */
export class Container<T> {
  private readonly items: Dictionary<T> = {};

  add(key: string, value: T)
  {
    if (key in this.items)
      throw new Error("A value with the specified key is already registered.");

    this.items[key] = value;
  }

  get(key: string): Nullable<T>
  {
    return this.items[key] || null;
  }

  has(key: string): boolean
  {
    return key in this.items;
  }

  remove(key: string): void
  {
    delete this.items[key];
  }
}